module.exports = __webpack_public_path__ + "static/telepathic-8119ed346f5f856245a8560301076ce3.png";